import { useState } from "react";
import { useSearchParams } from "react-router";
import { CenterSpinner } from "~/atoms/spinner";
import HeadingPage from "~/molecules/HeadingPage";
import { Toolbar } from "~/molecules/Toolbar";
import { getAnnualWheelEntries } from "./documentsStub";
import { useAnnualWheelEvents } from "./eventsStub";
import { groupByReviewFrom, toDocumentReviews } from "./helpers";
import { ReviewWindowsCharts } from "./ReviewWindowsCharts";
import { useText } from "./text";
import { DocumentHistoryPicker } from "./timeline/DocumentHistoryPicker";
import { annualWheelTabs } from "./types";
import "./pins.css";

// A prototype of the annual wheel and the timeline, on made-up documents and events
export default function AnnualWheelPrototypePage() {
  const text = useText();
  const [searchParams, setSearchParams] = useSearchParams();
  const [today] = useState(() => new Date());
  const { data: events } = useAnnualWheelEvents();
  const entries = getAnnualWheelEntries();

  if (!events) return <CenterSpinner />;

  const tabParam = searchParams.get("tab");
  const tab = annualWheelTabs.find((value) => value === tabParam) ?? "wheel";
  // Only the timeline follows one document through its reviews
  const selectedEntryId = Number(searchParams.get("document"));
  const selectedEntry =
    tab === "line"
      ? entries.find(({ id }) => id === selectedEntryId)
      : undefined;
  const documentReviews = toDocumentReviews(
    selectedEntry ? [selectedEntry] : entries,
  );
  const setParam = (key: string, value?: string) =>
    setSearchParams((previous) => {
      const next = new URLSearchParams(previous);

      if (value === undefined) next.delete(key);
      else next.set(key, value);

      return next;
    });

  return (
    <div className="container space-y-4 py-7">
      <HeadingPage title={text.header} />

      {tab === "line" && (
        <Toolbar
          left={
            <DocumentHistoryPicker
              entries={entries}
              selectedEntry={selectedEntry}
              onSelect={(entry) =>
                setParam("document", entry && String(entry.id))
              }
            />
          }
        />
      )}

      <ReviewWindowsCharts
        today={today}
        documentReviews={documentReviews}
        reviewWindows={groupByReviewFrom(documentReviews)}
        events={events}
        selectedEntry={selectedEntry}
        tab={tab}
        onTabChange={(value) => setParam("tab", value)}
      />
    </div>
  );
}
